import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routerConfig } from "./routes";
import { Toaster } from "sonner";
import Done from "@/assets/comman/Done";
import Feedback from "@/assets/comman/Feedback";
import Error from "./assets/comman/Error";
import { AlertCircleIcon } from "lucide-react";

const viteBaseUrl = import.meta.env.BASE_URL ?? "/";
const routerBasename =
  viteBaseUrl === "/" ? "/" : viteBaseUrl.replace(/\/$/, "");

const router = createBrowserRouter(routerConfig, { basename: routerBasename });
const queryClient = new QueryClient();

function App() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster
        position="top-right"
        icons={{
          success: <Done />,
          error: <Error />,
          info: <AlertCircleIcon color="#0552D6" />,
          loading: <Feedback />,
        }}
        closeButton
        duration={4000}
      />
      <div dir={isRTL ? "rtl" : "ltr"} className={isRTL ? "rtl" : "ltr"}>
        <RouterProvider router={router} />
      </div>
    </QueryClientProvider>
  );
}

export default App;
